type Action = any & { type: string };
type ReducerFunction<T> = (state: T, action: Action) => T;

export const makeReducer =
  <StateType>(init: StateType, config: Record<string, ReducerFunction<StateType>>) =>
  (maybeState: StateType | undefined, action: Action): StateType => {
    // Redux calls reducers with `undefined` state on init, so the default must be applied here
    // rather than as a default parameter (which would have to come last).
    const state = maybeState === undefined ? init : maybeState;
    const stateHandler = config[action.type];
    if (stateHandler) {
      return stateHandler(state, action);
    }
    return state;
  };
